// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ICrG","itemTitle":"ClientEmergencyInfo_itemTitle__295GZ","itemText":"ClientEmergencyInfo_itemText__1Fiob"};